import getContextualSourceId from "../getContextualSourceId/getContextualSourceId";

const getEndemicAdWithSourceId = (queried, menuNode) =>
{
    const ad = queried.globalNavEndemics?.endemicAds?.nodes.find((node) => node.adHocKey.toLowerCase() === menuNode.label.toLowerCase());
    const currentCtaUrl = ad?.buttonUrl;

    if (!currentCtaUrl || !currentCtaUrl.includes('#'))
    {
        return ad;
    }

    let buttonUrl = currentCtaUrl;

    try
    {
        let articleId = null;
        if (queried?.post?.databaseId != null)
        {
            articleId = queried.post.databaseId;
        }
        else if (queried?.page?.databaseId != null)
        {
            articleId = `pg${queried.page.databaseId}`;
        }

        const params = { articleId };

        if (articleId)
        {
            const baseSuffix = currentCtaUrl.split("#sourceid")[1]?.replace(/^[-_]/, "") || "";
            const shouldIncludeNavPrefix = baseSuffix.length > 0 && !baseSuffix.startsWith('nav-');
            const suffix = shouldIncludeNavPrefix ? `nav-${baseSuffix}` : baseSuffix;

            params.suffix = suffix;
        }

        const contextualSourceId = getContextualSourceId(params);

        // Remove suffix after the #
        const baseUrl = currentCtaUrl.split("#")[0];

        const url = new URL(baseUrl);
        url.searchParams.set('sourceid', contextualSourceId);
        buttonUrl = url.toString();
    }
    catch (error)
    {
        console.error('Error processing endemic ad with source ID:', error);
    }

    return {
        ...ad,
        buttonUrl,
    };
}

export default getEndemicAdWithSourceId;
